import { useEffect, useRef, useState } from "react";

import { formatarNumero, lerNumero, normalizarDigitacao } from "./campo-decimal.mascara";
import type { CampoDecimalProps } from "./types-campo-decimal";

export function useCampoDecimal({
  label,
  labelOculto,
  prefixo,
  casas,
  value,
  onChange,
  error,
  placeholder,
  required,
  disabled,
  foco = 0,
  name,
  testId,
}: CampoDecimalProps) {
  const [texto, setTexto] = useState(() => (value === null ? "" : formatarNumero(value, casas)));
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setTexto((atual) =>
      lerNumero(atual) === value ? atual : value === null ? "" : formatarNumero(value, casas),
    );
  }, [value, casas]);

  useEffect(() => {
    if (foco > 0) inputRef.current?.focus();
  }, [foco]);

  const digitar = (novo: string) => {
    const normalizado = normalizarDigitacao(novo, casas);
    if (normalizado === null) return;
    setTexto(normalizado);
    onChange(lerNumero(normalizado));
  };

  const sair = () => {
    const numero = lerNumero(texto);
    setTexto(numero === null ? "" : formatarNumero(numero, casas));
  };

  return {
    label,
    labelOculto,
    prefixo,
    prefixoTestId: testId ? `${testId}-prefixo` : undefined,
    texto,
    inputRef,
    inputMode: casas === 0 ? ("numeric" as const) : ("decimal" as const),
    error: error ?? null,
    placeholder,
    required,
    disabled,
    name,
    testId,
    digitar,
    sair,
  };
}
